import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { GetSinglepatient, UpdateOrderComment, GetOrderComment, PatientRegistration_LabOrders, AddOrderPayment } from '../Services/PatientServicces';
import { GetPrescription } from '../Services/TestServices';
import 'bootstrap/dist/css/bootstrap.min.css';
import Female from '../assets/female-Pofile.jpg';
import Male from '../assets/Male.jpg';
import { Checkbox, Switch, Button } from '@mui/material';
import SpinnerModal from '../Spinner/SpinnerModal';
import moment from 'moment';
import { Reports, Generate_Reports, GetDoctorInfo, GetStaticResult, GetDataBySearch } from '../Services/TestServices';
import PrintReports from './PrintReports';
import { useReactToPrint } from 'react-to-print';
import { useApi } from '../ContextApi/ContextApi';
import { toast } from 'react-toastify';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded'; // Added icon for billing popup
import Modal from 'react-bootstrap/Modal';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import '../UI/PatientProfile.css';
import LabOrder from './LabOrder';

const PatientProfile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [ProfileData, setProfileData] = useState({});
  const [PrescriptionData, setPrescriptionData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const { isReportGenerate, setReport_generation_SubmissionStatus, SetCommentValue } = useApi();
  const [selectedTests, setSelectedTests] = useState([]);
  const [Fonts, SetFonts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const componentRef = useRef();
  const billingPrintRef = useRef(); // Ref for printing the billing layout if needed
  const { id } = useParams();
  const inputRefs = useRef([]);
  const [Comment, setComment] = useState('');
  const [QrCodeURl, SetQRCodeUrl] = useState([]);
  const [commentVisibility, setCommentVisibility] = useState({});
  const [STATICRESULTS, SETRESULTS] = useState([]);
  const [activeTab, setActiveTab] = useState('');
  const [groupedTests, setGroupedTests] = useState({});
  const [sortedOrderIDs, setSortedOrderIDs] = useState([]);
  const [isActive, setisActive] = useState(true);
  const [Ordercomment, setorderComment] = useState({
    orderID: '',
    comment: ''
  });

  // Modal States
  const [lgShow, setLgShow] = useState(false); // Lab Order Modal
  const [billingShow, setBillingShow] = useState(false); // New Billing Modal

  // Payment / Financial Record States
  const [paymentInput, setPaymentInput] = useState({ ReceivedAmount: '' });
  const [paymentSavedOrders, setPaymentSavedOrders] = useState({}); // { [orderID]: FinancialRecordDTO }
  const [isSavingPayment, setIsSavingPayment] = useState(false);

  sessionStorage.setItem('PatientID', id);

  const icon = ProfileData?.[0]?.sex === "male" ? <ManIcon className='genderIcon' /> : <WomanIcon className='genderIcon' />;

  // Dynamic order metrics extractor
  const getActiveOrderBilling = () => {
    if (!activeTab || !groupedTests[activeTab]) return { totalBill: 0, discount: 0, grandTotal: 0, tests: [] };
    const firstCategory = Object.keys(groupedTests[activeTab])[0];
    const firstTestRecord = groupedTests[activeTab][firstCategory]?.[0];
    
    // Collect all tests in this specific order for the itemized statement
    const allTestsInOrder = [];
    Object.keys(groupedTests[activeTab]).forEach(cat => {
      allTestsInOrder.push(...groupedTests[activeTab][cat]);
    });

    return {
      totalBill: firstTestRecord?.totalBill || 0,
      discount: firstTestRecord?.discount || 0,
      grandTotal: firstTestRecord?.grandTotal || 0,
      receivedAmount: firstTestRecord?.receivedAmount || 0,
      dueAmount: firstTestRecord?.dueAmount || 0,
      tests: allTestsInOrder
    };
  };

  const currentBilling = getActiveOrderBilling();

  // Master test catalog, used only to detect when a full category/sub-category
  // profile (e.g. all CBC tests) has been billed, so the receipt can collapse
  // it into a single line - same logic as LabOrder.jsx's print receipt.
  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    const getTestsList = async () => {
      try {
        const response = await GetDataBySearch({ LabID: sessionStorage.getItem('LabID') });
        setSearchData(response);
      } catch (error) {
        console.log('Error while fetching test catalog', error);
      }
    };
    getTestsList();
  }, []);

  const receiptLineItems = useMemo(() => {
    const groups = {};
    (currentBilling.tests || []).forEach((testItem) => {
      const key = `${testItem.categorY_VALUE || ''}|${testItem.suB_CATEGORY_VALUE || ''}`;
      if (!groups[key]) groups[key] = [];
      groups[key].push(testItem);
    });

    const items = [];
    Object.entries(groups).forEach(([key, testsInGroup]) => {
      const [category, subCategory] = key.split('|');
      const profileSize = searchData.filter(
        (t) => (t.categorY_VALUE || '') === category && (t.suB_CATEGORY_VALUE || '') === subCategory
      ).length;

      const isFullProfile = profileSize > 1 && testsInGroup.length === profileSize;

      if (isFullProfile) {
        const amount = testsInGroup.reduce((sum, t) => sum + (parseFloat(t.testPrice) || 0), 0);
        items.push({
          key,
          name: (subCategory || category || 'PROFILE').toUpperCase(),
          rate: amount,
          qty: 1,
          amount,
        });
      } else {
        testsInGroup.forEach((testItem, index) => {
          const priceVal = parseFloat(testItem.testPrice) || 0;
          items.push({
            key: testItem.testID || index,
            name: (testItem.testName || 'TEST').toUpperCase(),
            rate: priceVal,
            qty: 1,
            amount: priceVal,
          });
        });
      }
    });
    return items;
  }, [currentBilling.tests, searchData]);

  useEffect(() => {
    GetprofileData();
  }, [id]);

  const GetprofileData = async () => {
    setIsLoading(true);
    try {
      const LabID = sessionStorage.getItem('LabID');
      const data = await GetSinglepatient(id, LabID);
      setProfileData(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTests.length > 0) {
      PrintReport();
    }
  }, [selectedTests]);

  const print = useReactToPrint({
    content: () => componentRef.current,
  });

  // Print helper for the billing receipt specifically
  const printBillingReceipt = useReactToPrint({
    content: () => billingPrintRef.current,
  });

  const PrintReport = async () => {
    setIsLoading(true);
    try {
      const patientID = sessionStorage.getItem('PatientID');
      const LabID = sessionStorage.getItem('LabID');
      const IDs = selectedTests.map(x => x.labOrderID).join('&SelectedIDs=');
      const Url = `https://securelab.api.sehhasolutions.com/api/Home/QRCodeData?PatientID=${patientID}&LabID=${LabID}&SelectedIDs=${IDs}`;
      SetQRCodeUrl(Url);
      const TestIDs = selectedTests.map(x => x.labOrderID);
      const data = await Reports(patientID, LabID, TestIDs);
      setReportData(data);
    } catch (error) {
      console.error('Failed to fetch reports:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    GetPresciptionData();
    setReport_generation_SubmissionStatus(false);
  }, [id, isReportGenerate]);

  const GetPresciptionData = async () => {
    const LabID = sessionStorage.getItem('LabID');
    const response = await GetPrescription(id, LabID);
    setPrescriptionData(response);
  };

  const handleCheckboxChange = (testID, labOrderID) => {
    const LabID = sessionStorage.getItem('LabID');
    const patientID = sessionStorage.getItem('PatientID');
    const newTest = { LabID, patientID, testID, labOrderID };
    setSelectedTests(prevSelectedTests => {
      const testExists = prevSelectedTests.some(test => test.testID === testID && test.labOrderID === labOrderID);

      if (testExists) {
        return prevSelectedTests.filter(test => !(test.testID === testID && test.labOrderID === labOrderID));
      } else {
        return [...prevSelectedTests, newTest]
      }
    });
  };

  const handleSelectAllChange = (event, orderID, categoryvalue) => {
    const checked = event.target.checked;

    setSelectAll((prev) => ({
      ...prev,
      [`${orderID}-${categoryvalue}`]: checked
    }));

    setSelectedTests((prevSelectedTests) => {
      if (checked) {
        const allTests = PrescriptionData
          .filter(test =>
            test.testResult &&
            parseInt(orderID, 10) === test.orderID &&
            test.categorY_VALUE === categoryvalue
          )
          .map(test => ({
            LabID: sessionStorage.getItem('LabID'),
            patientID: sessionStorage.getItem('PatientID'),
            testID: test.testID,
            labOrderID: test.labOrderid,
            categorY_VALUE: categoryvalue,
          }));

        return [...prevSelectedTests, ...allTests].filter(
          (test, index, self) =>
            index === self.findIndex((t) => t.testID === test.testID && t.labOrderID === test.labOrderID)
        );
      } else {
        return prevSelectedTests.filter(
          (test) => test.categorY_VALUE !== categoryvalue
        );
      }
    });
  };

  useEffect(() => {
    const grouped = PrescriptionData.reduce((acc, test) => {
      if (!acc[test.orderID]) {
        acc[test.orderID] = {};
      }
      if (!acc[test.orderID][test.categorY_VALUE]) {
        acc[test.orderID][test.categorY_VALUE] = [];
      }
      acc[test.orderID][test.categorY_VALUE].push(test);
      Object.keys(acc[test.orderID]).forEach((category) => {
        acc[test.orderID][category].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      });
      return acc;
    }, {});

    const orderIDs = Object.keys(grouped)
      .map((id) => parseInt(id))
      .sort((a, b) => b - a);

    setGroupedTests(grouped);
    setSortedOrderIDs(orderIDs);

    if (isActive && orderIDs.length > 0) {
      setActiveTab(orderIDs[0] || null);
      setisActive(false);
    }
  }, [PrescriptionData]);

  const handleKeyDown = (event, testID, LabOrderID, index, categoryCode) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      const currentKey = `${index}_${categoryCode}`;
      handleSave(testID, LabOrderID, currentKey);
    }
  };

  const handleInputChange = (testID, LabOrderID, value) => {
    setPrescriptionData((prevPrescriptionData) =>
      prevPrescriptionData.map(test =>
        (test.testID === testID && test.labOrderid === LabOrderID) ? { ...test, labOrderID_In_GR: LabOrderID, testResult: value } : test
      )
    );
  };

  const handleSave = async (testID, LabOrderID, currentKey) => {
    setIsLoading(true);
    try {
      const testToSave = PrescriptionData.find(test => test.testID === testID && test.labOrderid === LabOrderID);
      const LabID = sessionStorage.getItem('LabID');
      const patientID = sessionStorage.getItem('PatientID');

      const savedData = {
        ...testToSave,
        LabID,
        patientID,
        reportID: testToSave.reportID || 0,
        Comment: testToSave.comment
      };
      if (savedData.testResult == '' || savedData.testResult == null) {
        toast.error("Result required")
      } else {
        const Response = await Generate_Reports(savedData);
        if (Response) {
          toast.success("Report Generated Successfully");
          setReport_generation_SubmissionStatus(true);
          const keys = Object.keys(inputRefs.current);
          const currentIndex = keys.indexOf(currentKey);

          if (currentIndex !== -1 && keys[currentIndex + 1]) {
            inputRefs.current[keys[currentIndex + 1]].focus();
          }
        }
      }
    } catch (error) {
      toast.error("Error occurred while saving data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatTextWithLineBreaks = (text) => {
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const OnchangeComment = (TestID, OrderID, Value) => {
    setPrescriptionData((prevPrescriptionData) =>
      prevPrescriptionData.map(test =>
        (test.testID === TestID && test.labOrderid === OrderID) ? { ...test, comment: Value } : test
      )
    );
  }

  const toggleCommentVisibility = (testID, labOrderID) => {
    setCommentVisibility(prev => ({
      ...prev,
      [`${testID}-${labOrderID}`]: !prev[`${testID}-${labOrderID}`]
    }));
  };

  const STATICRESULT = async () => {
    try {
      const LabID = sessionStorage.getItem('LabID');
      const response = await GetStaticResult(LabID);
      SETRESULTS(response);
    }
    catch (error) {
      console.log("Error getting Static Result", error)
    }
  }
  useEffect(() => {
    STATICRESULT();
  }, [])

  const handleTabClick = (orderID) => {
    setActiveTab(orderID);
  };

  const handlOrdercomment = (e,ID) => {
    const value = e.target.value;
    setorderComment({
      orderID: ID,
      comment: value
    })
  }

  const Saveordercomment = () => {
    try {
      setIsLoading(true)
      const res = UpdateOrderComment(Ordercomment.orderID, Ordercomment.comment);
      if (res) {
        toast.success("Comment saved successfully");
        Getordercomment();
      }
    }
    catch (error) {
      console.log("getting error whi saving order comment", error)
    }
    finally {
      setIsLoading(false)
    }
  };
  
  const Getordercomment = async () => {
    try {
      setIsLoading(true)
      if (!activeTab) return
      const res = await GetOrderComment(activeTab);
      setorderComment(prevState => ({
        ...prevState,
        comment: res.comment?.toString() || ''
      }));
      SetCommentValue(res.comment?.toString() || '')
    }
    catch (error) {
      console.log("getting error whi getting order comment", error)
    }
    finally {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    Getordercomment();
  }, [activeTab])

  const [LabOrderData, setlabOrderData] = useState({});
  const [formData, setformData] = useState({
    PatientID: '',
    PatientName: '',
    ReferredBy: '',
    ContactNumber: '',
    gender: 'male',
    Age: '',
    Comments: '',
    DOB: '',
    Address: '',
    LaboratoryID: sessionStorage.getItem('LabID')
  });
  const [ModalHeadrData, SetModalHeaderData] = useState({
    patientName: '',
    age: '',
    Sex: ''
  });
  const AddLabOrder = () => {
    setLgShow(true)
    setformData((prevData) => ({
      ...prevData,
      PatientID: ProfileData?.[0]?.patientID
    }));
    SetModalHeaderData((prevData) => ({
      ...prevData,
      PatientName: ProfileData?.[0]?.patientName.toUpperCase(),
      age: ProfileData?.[0]?.age,
      Sex: ProfileData?.[0]?.sex,
    }))
  }

  const handleOrderFormSubmit = useCallback((orderFormData) => {
    if (orderFormData) {
      setlabOrderData(orderFormData);
    } else {
      toast.warning("no data has been selected")
    }
  }, []);

  const Submit = async () => {
    setIsLoading(true);
    try {
      if (LabOrderData.length > 0) {
        const response = await PatientRegistration_LabOrders(formData, LabOrderData);
        if (response) {
          toast.success('Action successfully');
          setLgShow(false)
          GetPresciptionData();
        }
      } else {
        toast.warning("Please add test")
      }
    } catch (error) {
      toast.error('Something went wrong while adding patient');
    } finally {
      setIsLoading(false);
    }
  }

  const { isheader, SetisHeader } = useApi();

  const handleSwitchChange = (event) => {
    SetisHeader(event.target.checked);
  };

  // Reset / hydrate the payment input whenever the billing popup is opened
  // or the active order changes, so each order's payment entry is independent.
  useEffect(() => {
    if (billingShow) {
      const existing = paymentSavedOrders[activeTab];
      setPaymentInput({ ReceivedAmount: existing ? existing.ReceivedAmount?.toString() : '' });
    }
  }, [billingShow, activeTab]);

  const handleReceivedAmountChange = (e) => {
    const value = e.target.value;
    // allow only numbers with an optional decimal point
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setPaymentInput({ ReceivedAmount: value });
    }
  };

  const computedDueAmount = (currentBilling.grandTotal || 0) - (parseFloat(paymentInput.ReceivedAmount) || 0);

  const handleSavePayment = async () => {
    if (!activeTab) return;
    const receivedAmount = parseFloat(paymentInput.ReceivedAmount) || 0;

    if (!paymentInput.ReceivedAmount || receivedAmount <= 0) {
      toast.error("Please enter a valid received amount");
      return;
    }

    const dueAmount = (currentBilling.grandTotal || 0) - receivedAmount;

    const payload = {
      PatientID: ProfileData?.[0]?.patientID ? parseInt(ProfileData[0].patientID) : null,
      LaboratoryID: parseInt(sessionStorage.getItem('LabID')),
      UpdatedBy: sessionStorage.getItem('UserName') || sessionStorage.getItem('FirstName') || '',
      TotalBill: currentBilling.totalBill || 0,
      Discount: currentBilling.discount || 0,
      GrandTotal: currentBilling.grandTotal || 0,
      ReceivedAmount: receivedAmount,
      DueAmount: dueAmount,
      OrderId: parseInt(activeTab)
    };

    setIsSavingPayment(true);
    try {
      const response = await AddOrderPayment(payload);
      if (response) {
        toast.success("Payment record added successfully");
        setPaymentSavedOrders((prev) => ({
          ...prev,
          [activeTab]: payload
        }));
      }
    } catch (error) {
      toast.error("Something went wrong while saving payment");
    } finally {
      setIsSavingPayment(false);
    }
  };

  return (
    <>
      {isLoading && <SpinnerModal isLoading={isLoading} />}
      <div style={{ display: 'none' }}>
        <PrintReports reportData={reportData} QrCodeURL={QrCodeURl} ref={componentRef} />
      </div>
      <div className='Container2' style={{ padding: '0px 12px' }}>
        <div className='Common-min-height'>
          <div className='p-1 Profile-header common-box-shadow common-bg-white common-br-3px'>
            <div className='row'>
              <div className='col-sm-3 d-flex'>
                <div className='Pics-div'>
                  {ProfileData?.[0]?.sex === "male" ? (<img className='img-profile' src={Male} alt="Male Profile" />) : (<img className='img-profile' src={Female} alt="Female Profile" />)}
                </div>
                <div className='common-line-height ml-2' style={{ marginLeft: '6px', textAlign: 'start' }}>
                  <span className='commont-Font-Bold common-FontSize-small'>{ProfileData?.[0]?.patientName?.toUpperCase()}</span><br></br>
                  <span className='common-Font-10'>{ProfileData?.[0]?.sex} - {ProfileData?.[0]?.age} Year</span><br></br>
                  <span className='common-Font-10'>MR No: {ProfileData?.[0]?.patientID}-{sessionStorage.getItem('LabID')}</span><br></br>
                </div>
              </div>

              <div className='col-sm-2' style={{ marginLeft: '10px' }} >
                <div>
                  <div style={{ textAlign: 'start' }}>
                    <span className='common-FontSize-small common-color'><PhoneIphoneOutlinedIcon className='phone-icon' /> Phone No</span><br></br>
                    <span style={{marginLeft: '10px'}} className='common-FontSize-small'> {ProfileData?.[0]?.contactNumber}</span>
                  </div>
                </div>
              </div>
              <div className='col-sm-3' >
                <div style={{ textAlign: 'start' }}>
                  <span className='common-FontSize-small common-color'><CalendarMonthRoundedIcon className='ProfileIcon' />Registered Date</span><br></br>
                  <span className='common-FontSize-small'>{moment(ProfileData?.[0]?.created_at).format('YYYY-MM-DD')}</span>
                </div>
              </div>
              <div className='col-sm-3' >
                <div style={{ textAlign: 'start' }}>
                  <span className='common-FontSize-small common-color'><LocationOnIcon className='ProfileIcon' /> Address </span> <br></br>
                  <span className='common-FontSize-small'>{ProfileData?.[0]?.address}</span>
                </div>
              </div>
            </div>
          </div>
          
          <div style={{ textAlign: 'end', marginBottom: '3px', marginTop: "10px" }}>
            <Button className='Switch-toggle' variant="outlined">
              Print Header<Switch checked={isheader} onChange={(handleSwitchChange)} inputProps={{ 'aria-label': 'controlled' }} />
            </Button>
            <Button className='common-button' variant="contained" type='button' disabled={!selectedTests.length > 0} onClick={print} >
              <PrintRoundedIcon sx={{ width: '15px', height: '15px' }} />    Print
            </Button>
            <Button className='common-button' variant="contained" type='button' onClick={AddLabOrder} >
              Add Lab Order
            </Button>
          </div>

          <div>
            <div style={{ display: 'flex', flexDirection: 'row', height: '100%', gap: '10px' }}>
              {/* Left side for tabs */}
              <div className='profile-vertical-parent common-box-shadow common-bg-white common-br-3px'>
                <div className="profile-vertical-tabs common-FontSize-small">
                  <div>
                    <span>Orders</span>
                    <hr style={{ margin: 0 }}></hr>
                  </div>
                  <div className="nav flex-column nav-pills" role="tablist">
                    {Object.keys(groupedTests)
                      .sort((a, b) => Number(b) - Number(a))
                      .map((orderID) => {
                        const mainCategories = Object.keys(groupedTests[orderID]);
                        const firstTest = groupedTests[orderID][mainCategories[0]]?.[0];
                        return (
                          <a
                            key={orderID}
                            className={`nav-link ${activeTab === orderID ? 'profile-tab-active' : 'profile-tab'}`}
                            onClick={() => handleTabClick(orderID)}
                            style={{ cursor: 'pointer' }}
                          >
                            <span className='common-Font-10'>
                              {moment(firstTest?.createdAt).format('DD/MM/YY')} | Order Sent
                            </span>
                            <br />
                            <span className='common-Font-10'>{firstTest?.patientName}</span>
                            <br />
                            {mainCategories.map((category, index) => (
                              <span key={index} className='common-Font-10'>
                                {index > 0 && ', '}
                                {category}
                              </span>
                            ))}
                          </a>
                        );
                      })}
                  </div>
                </div>
              </div>

              {/* Right side for content of selected tab */}
              <div className="profile-Tabs-content common-box-shadow common-bg-white common-br-3px">
                {(activeTab && groupedTests[activeTab]) && (
                  <>
                    <div className="details-heading d-flex justify-content-between align-items-center">
                      <div>
                        <span>Order id: {activeTab}</span>
                        <span style={{ marginLeft: '10px' }}>
                          Order on: {moment(Object.values(groupedTests[activeTab])?.[0]?.[0]?.createdAt).format('YYYY-MM-DD')}
                        </span>
                      </div>
                      {/* View Billing Invoice Action Trigger Button */}
                      <Button 
                        size="small" 
                        variant="outlined" 
                        color="primary" 
                        onClick={() => setBillingShow(true)}
                        style={{ textTransform: 'none', fontSize: '11px', height: '26px' }}
                      >
                        <ReceiptLongRoundedIcon sx={{ width: '14px', height: '14px', marginRight: '4px' }} />
                        View Billing Report
                      </Button>
                    </div>

                    {Object.keys(groupedTests[activeTab]).map((mainCategory, idx) => (
                      <div key={idx}>
                        <h4 className="common-FontSize-small">{mainCategory}</h4>
                        <table className="table common-FontSize-small">
                          <thead>
                            <tr>
                              <th className="profile-th">
                                <Checkbox
                                  checked={selectAll[`${activeTab}-${mainCategory}`] || false}
                                  onChange={(event) => handleSelectAllChange(event, activeTab, mainCategory)}
                                  sx={{
                                    color: '#2c6bd7',
                                    padding: '0px',
                                    '&.Mui-checked': { color: '#2c6bd7', padding: '0px' },
                                    width: '20px',
                                    height: '20px'
                                  }}
                                />
                              </th>
                              <th className="profile-th">Test Name</th>
                              <th className="profile-th">Normal Range</th>
                              <th className="profile-th">Result</th>
                              <th className="profile-th">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {groupedTests[activeTab][mainCategory].map((data, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td className="common-FontSize-small gray profile-td">
                                    <Checkbox
                                      disabled={!data.testResult}
                                      sx={{ color: '#2c6bd7', '&.Mui-checked': { color: '#2c6bd7' }, padding: '0px' }}
                                      checked={selectedTests.some(
                                        (test) => test.testID === data.testID && test.labOrderID === data.labOrderid
                                      )}
                                      onChange={() => handleCheckboxChange(data.testID, data.labOrderid)}
                                    />
                                  </td>
                                  <td className="common-FontSize-small profile-td-100px">{data.testName}</td>
                                  <td className="common-FontSize-small profile-td-100px">
                                    {formatTextWithLineBreaks(data.normalRange)}
                                  </td>
                                  <td className="common-FontSize-small profile-td">
                                    <input
                                      required
                                      className={`result-Textbox ${(data.testResult && data.testResult.toUpperCase() != 'NILL' && data.testResult.toUpperCase() != 'NULL') ? 'green-background' : (data.testResult || '').toUpperCase() == 'NILL' ? 'red-background' : ''}`}
                                      value={data.testResult || ''}
                                      onFocus={() => {
                                        // Urine examination rows come pre-filled with a default
                                        // result ("NILL" / "null"). It's only a convenience default
                                        // until a report is actually saved, so clear it the moment
                                        // the user clicks in to type a real value. A result that
                                        // has already been saved (data.reportID set) is left alone.
                                        const current = (data.testResult || '').trim().toLowerCase();
                                        if (!data.reportID && (current === 'nill' || current === 'null')) {
                                          handleInputChange(data.testID, data.labOrderid, '');
                                        }
                                      }}
                                      onChange={(e) => handleInputChange(data.testID, data.labOrderid, e.target.value)}
                                      onKeyDown={(e) => handleKeyDown(e, data.testID, data.labOrderid, index, data.categorY_CODE)}
                                      ref={(el) => (inputRefs.current[`${index}_${data.categorY_CODE}`] = el)}
                                      list={`Suggestion-${data.testID}`}
                                    />
                                    <datalist id={`Suggestion-${data.testID}`}>
                                      <option value="Nill" />
                                      <option value="Positive" />
                                      <option value="Negative" />
                                      {STATICRESULTS
                                        .filter((RS) => RS.testID == null || String(RS.testID) === String(data.testID))
                                        .map((RS, i) => (
                                          <option key={RS.srid ?? i} value={RS.sResult} />
                                        ))}
                                    </datalist>
                                  </td>
                                  <td className="common-FontSize-small profile-td">
                                    {data.reportID ? (
                                      <button
                                        disabled={!data.testResult}
                                        className="Result-Updatebutton"
                                        onClick={() => handleSave(data.testID, data.labOrderid, index)}
                                      >
                                        Update
                                      </button>
                                    ) : (
                                      <button
                                        disabled={!data.testResult}
                                        className="Result-Savebutton"
                                        onClick={() => handleSave(data.testID, data.labOrderid, index)}
                                      >
                                        Save
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      className="Comment-button"
                                      onClick={() => toggleCommentVisibility(data.testID, data.labOrderid)}
                                    >
                                      Comment
                                    </button>
                                  </td>
                                </tr>
                                {commentVisibility[`${data.testID}-${data.labOrderid}`] && (
                                  <tr>
                                    <td colSpan="5">
                                      <textarea
                                        value={data.comment}
                                        onChange={(e) => OnchangeComment(data.testID, data.labOrderid, e.target.value)}
                                        className="form-control common-Input"
                                        placeholder="Add comment here"
                                      />
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ))}

                    {/* Integrated Dynamic Order Financial Summary Segment */}
                    {/* <div className="mt-3 p-2 common-br-3px" style={{ background: '#f8f9fa', border: '1px solid #e3e6f0' }}>
                      <div className="d-flex align-items-center mb-2 text-primary">
                        <AccountBalanceWalletRoundedIcon sx={{ width: '18px', height: '18px', marginRight: '5px' }} />
                        <span className="commont-Font-Bold common-FontSize-small">Billing Details</span>
                      </div>
                      <div className="row text-center">
                        <div className="col-sm-4">
                          <div className="common-Font-10 text-muted text-uppercase">Total Bill</div>
                          <div className="commont-Font-Bold text-dark" style={{ fontSize: '13px' }}>
                            {currentBilling.totalBill}
                          </div>
                        </div>
                        <div className="col-sm-4" style={{ borderLeft: '1px solid #e3e6f0', borderRight: '1px solid #e3e6f0' }}>
                          <div className="common-Font-10 text-muted text-uppercase">Discount Given</div>
                          <div className="commont-Font-Bold text-danger" style={{ fontSize: '13px' }}>
                            {currentBilling.discount}
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="common-Font-10 text-muted text-uppercase">Grand Total</div>
                          <div className="commont-Font-Bold text-success" style={{ fontSize: '14px' }}>
                            {currentBilling.grandTotal}
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </>
                )}

                <div className="mt-3">
                  <div className='report-comment'>
                    <span className='common-FontSize-small'>Add Report Comment</span>
                  </div>
                  <div>
                    <textarea value={Ordercomment.comment} onChange={(e) => handlOrdercomment(e, activeTab)} className='form-control common-Input' />
                  </div>
                  <div>
                    <Button onClick={Saveordercomment} style={{ float: 'inline-end', marginTop: '5px' }} className='common-button' variant="contained">Save</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lab Order Creation Modal */}
      <div>
        <Modal size="xl" show={lgShow} dialogClassName="modal-90w" style={{ marginLeft: '10px' }} aria-labelledby="example-custom-modal-styling-title">
          <Modal.Header className='d-flex align-center justify-content-between'>
            <Modal.Title className='d-flex align-center'>
              <h4 className='common-FontFamily'>{ModalHeadrData?.PatientName?.toUpperCase()}</h4>
              <p className='common-FontFamily common-FontSize-small'>{ModalHeadrData.age} Year | {ModalHeadrData.Sex}</p>
            </Modal.Title>
            <div>
              <button className="Model-Cross" onClick={() => setLgShow(false)}> <CloseRoundedIcon /></button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <LabOrder onSubmit={handleOrderFormSubmit}   patientName={ProfileData?.[0]?.patientName.toUpperCase()}/>
            <Button style={{ marginTop: '20px', float: 'inline-end' }} onClick={Submit} variant="contained" type='button' className="common-button">Save</Button>
          </Modal.Body>
        </Modal>
      </div>

    
      {/* 58mm Thermal Receipt Billing Popup Modal */}
      {billingShow && (
        <div className="custom-print-overlay">
          <div className="custom-print-popup">
            
            {/* Scrollable Receipt Component wrapped in 58mm dimension styling */}
            <div className="popup-receipt-content" ref={billingPrintRef}>
              <div style={{ borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '6px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>LAB Name:</span>
                  <span>
                    {(sessionStorage.getItem('FirstName') || '') + ' ' + (sessionStorage.getItem('LastName') || '') || 'N/A'}
                  </span>
                </div>
                
                {/* Patient Name Field */}
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>PATIENT:</span>
                  <span style={{ fontWeight: 'bold' }}>
                    {(ProfileData?.[0]?.patientName || 'N/A').toUpperCase()}
                  </span>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>MR No:</span>
                  <span>{ProfileData?.[0]?.patientID}-{sessionStorage.getItem('LabID')}</span>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>ORDER ID:</span>
                  <span>{activeTab || 'N/A'}</span>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>DATE:</span>
                  <span>
                    {currentBilling.tests?.[0]?.createdAt 
                      ? moment(currentBilling.tests[0].createdAt).format('YYYY-MM-DD') 
                      : new Date().toLocaleDateString()}
                  </span>
                </div>
              </div>

              {/* Services Render Table */}
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
                <thead>
                  <tr style={{ borderBottom: '1.5px solid #000', textAlign: 'left' }}>
                    <th style={{ width: '55%' }}>Services</th>
                    <th style={{ textAlign: 'right', width: '20%' }}>Rate</th>
                    <th style={{ textAlign: 'center', width: '10%' }}>Qty</th>
                    <th style={{ textAlign: 'right', width: '15%' }}>AMT</th>
                  </tr>
                </thead>
                <tbody>
                  {receiptLineItems.map((item) => (
                    <tr key={item.key} style={{ verticalAlign: 'top' }}>
                      <td style={{ padding: '4px 0', wordBreak: 'break-word' }}>
                        {item.name}
                      </td>
                      <td style={{ padding: '4px 0', textAlign: 'right' }}>{item.rate}</td>
                      <td style={{ padding: '4px 0', textAlign: 'center' }}>{item.qty}</td>
                      <td style={{ padding: '4px 0', textAlign: 'right' }}>{item.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Financial Breakdowns */}
              <div style={{ marginTop: '4px', borderTop: '1px solid #000', paddingTop: '4px' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', fontWeight: 'bold' }}>
                  <span style={{ width: '40%', textAlign: 'left' }}>Total</span>
                  <span style={{ width: '30%', textAlign: 'right' }}>{currentBilling.totalBill}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', color: '#dc3545' }}>
                  <span style={{ width: '40%', textAlign: 'left' }}>Discount</span>
                  <span style={{ width: '30%', textAlign: 'right' }}>-{currentBilling.discount}</span>
                </div>

                {/* Only show Received/Due on the printed receipt once a payment has actually been recorded */}
               {(paymentSavedOrders[activeTab] || Object.values(groupedTests[activeTab])?.[0]?.[0]?.receivedAmount) && (
                <>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '2px' }}>
                    <span style={{ width: '40%', textAlign: 'left' }}>Paid</span>
                    <span style={{ width: '30%', textAlign: 'right' }}>
                      {Object.values(groupedTests[activeTab])?.[0]?.[0]?.receivedAmount ??
                        paymentSavedOrders[activeTab]?.ReceivedAmount}
                    </span>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <span style={{ width: '40%', textAlign: 'left' }}>Balance Due</span>
                    <span style={{ width: '30%', textAlign: 'right' }}>
                      {Object.values(groupedTests[activeTab])?.[0]?.[0]?.dueAmount ??
                        paymentSavedOrders[activeTab]?.DueAmount}
                    </span>
                  </div>
                </>
              )}
              </div>

              {/* Print Footer Policies */}
              <div style={{ marginTop: '15px', fontSize: '9px', textAlign: 'left', borderTop: '1px solid #000', paddingTop: '5px' }}>
                <div>* This is a computer generated receipt.</div>
                <div>* Please bring this receipt for collection of reports.</div>
              </div>
            </div>

            {/* Payment Entry Section - kept outside the print ref so it never appears on the printed receipt */}
            <div className="popup-payment-section" style={{ marginTop: '8px', borderTop: '1px dashed #000', paddingTop: '6px' }}>
             {(paymentSavedOrders[activeTab]) && (
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px' }}>
                        <span>Received Amt:</span>
                        <span style={{ fontWeight: 'bold' }}>
                          { paymentSavedOrders[activeTab]?.ReceivedAmount}
                        </span>
                      </div>

                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px' }}>
                        <span>Due Amt:</span>
                        <span style={{ fontWeight: 'bold' }}>
                          { paymentSavedOrders[activeTab]?.DueAmount}
                        </span>
                      </div>

                      <div
                        style={{
                          textAlign: 'center',
                          color: '#28a745',
                          fontSize: '10px',
                          marginTop: '4px'
                        }}
                      >
                        ✓ Payment Recorded
                      </div>
                    </div>
                  )}
              {(Object.values(groupedTests[activeTab])?.[0]?.[0]?.receivedAmount == 0 && !paymentSavedOrders[activeTab])  &&  (
               
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '6px' }}>
                    <span style={{ fontSize: '11px' }}>Received Amt:</span>
                    <input
                      type="text"
                      value={paymentInput.ReceivedAmount}
                      onChange={handleReceivedAmountChange}
                      placeholder="0"
                      style={{ width: '100px', fontSize: '11px', textAlign: 'right', border: '1px solid #ccc', padding: '3px 5px', borderRadius: '3px' }}
                    />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px', fontSize: '11px' }}>
                    <span>Due Amt:</span>
                    <span style={{ fontWeight: 'bold' }}>{computedDueAmount.toFixed(2)}</span>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary w-100 common-FontFamily common-FontSize-small"
                    style={{ marginTop: '6px' }}
                    onClick={handleSavePayment}
                    disabled={isSavingPayment || !paymentInput.ReceivedAmount}
                  >
                    {isSavingPayment ? 'Saving...' : 'Save Payment'}
                  </button>
                </div>
              )}
            </div>

            {/* Interaction Toolbar */}
            <div className="popup-action-row">
              <button 
                type="button" 
                className="btn btn-success w-50 common-FontFamily common-FontSize-small" 
                onClick={printBillingReceipt}
              >
                Print
              </button>
              <button 
                type="button" 
                className="btn btn-danger w-50 common-FontFamily common-FontSize-small" 
                onClick={() => setBillingShow(false)}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default PatientProfile;
